export const EARN_PAGE_HEAD_SECTION_ID = 'drift-earn-page-head-section';
export const BORROW_LEND_PAGE_HEAD_SECTION_ID =
	'drift-borrow-lend-page-head-section';
export const EXPLORE_COMPARE_HEAD_SECTION_ID =
	'drift-explore-compare-head-section';
